<span id="inputItemFields">
  <mat-form-field [ngClass]="{'full-width': forSalesOrder == true}">
    <mat-label>Name</mat-label>
    <input (keyup.enter)="onEnter()" class="ta-itemsearch-name" matInput placeholder="" [(ngModel)]="itemRequest.name" data-hj-whitelist>
    <button class="mat-mdc-button-transparentBackground-BlackColor"  *ngIf="itemRequest.name" matSuffix mat-icon-button aria-label="Clear"
      (click)="itemRequest.name=''" style="color: black !important;">
      <mat-icon>close</mat-icon>
    </button>
    <mat-hint
      *ngIf="itemRequest.id == '' && (itemRequest.name == '' || itemRequest.name.length < 1 ) && (itemRequest.categoryDescription == '' || itemRequest.categoryDescription.length <3)">
      At least 1 characters</mat-hint>
  </mat-form-field>

  <mat-form-field [ngClass]="{'full-width': forSalesOrder == true}">
    <mat-label>Item No</mat-label>
    <input (keyup.enter)="onEnter()" class="ta-itemsearch-itemno" matInput placeholder="" [(ngModel)]="itemRequest.id" data-hj-whitelist>
    <button class="mat-mdc-button-transparentBackground-BlackColor"  *ngIf="itemRequest.id" matSuffix mat-icon-button aria-label="Clear" (click)="itemRequest.id=''" style="color: black !important;">
      <mat-icon>close</mat-icon>
    </button>
    <mat-hint
      *ngIf="itemRequest.id == '' && (itemRequest.name == '' || itemRequest.name.length < 1 ) && (itemRequest.categoryDescription == '' || itemRequest.categoryDescription.length <3)">
      At least 1 characters</mat-hint>
  </mat-form-field>

  <mat-form-field [ngClass]="{'full-width': forSalesOrder == true}">
    <mat-label>Category</mat-label>
    <input (keyup.enter)="onEnter()" class="ta-itemsearch-category" matInput placeholder="" [(ngModel)]="itemRequest.categoryDescription"
      data-hj-whitelist>
    <button  class="mat-mdc-button-transparentBackground-BlackColor"  *ngIf="itemRequest.categoryDescription" matSuffix mat-icon-button aria-label="Clear" style="color: black !important;"
      (click)="itemRequest.categoryDescription=''">
      <mat-icon>close</mat-icon>
    </button>
    <mat-hint
      *ngIf="itemRequest.id == '' && (itemRequest.name == '' || itemRequest.name.length < 1 ) && (itemRequest.categoryDescription == '' || itemRequest.categoryDescription.length <3)">
      At least 3 characters</mat-hint>
  </mat-form-field>
</span>

<hr style="margin-top: 0px;" *ngIf="currentWidth >= 768 && !forSalesOrder">

<div align="center">
  <!-- <div id="divItemSearch">
    <span id="leftItemSpace"></span> -->
  <button id="searchItemButton" mat-button
    [disabled]="itemRequest.id == '' && (itemRequest.name == '' || itemRequest.name.length < 1 ) && (itemRequest.categoryDescription == '' || itemRequest.categoryDescription.length <3)"
    [ngClass]="'ta-itemsearch-search pull-right text-white btn btn-sm btn-'+globals.colorTheme"
    (click)="searchItem()">Search</button>

    <!-- <button id="nextnextButton" mat-button #btnCreditCheckNext="matButton" [ngClass]="'mat-focus-indicator ta-customer-next text-white magin_5 btn btn-'+globals.colorTheme"
    (click)="openBookingsComplete();">nextnextButton</button> -->

</div>
<!-- 
<mat-action-row *ngIf="currentWidth < 768">
  <button mat-button
    [disabled]="itemRequest.id == '' && (itemRequest.name == '' || itemRequest.name.length < 1 ) && (itemRequest.categoryDescription == '' || itemRequest.categoryDescription.length <3)"
    [ngClass]="'pull-right text-white btn btn-sm btn-'+globals.colorTheme" (click)="searchItem()">Search</button>
</mat-action-row> -->

<div (window:resize)="onResize($event)"></div>